var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2 pl-3 ma-2"},[(_vm.userData && _vm.userData.OfficeId)?_c('div',[_c('img',{attrs:{"src":_vm.logoUrl}}),_c('div',{staticClass:"text-h6"},[_vm._v(" "+_vm._s(_vm.userData.OfficeName)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }